export const iconFontAwesomeClothingFashionGlasses = (
	<i className="fa-solid fa-glasses"></i>
);
